module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tab-panes/spk-tab-panes.component.scss
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tab-panes/spk-tab-panes.component.scss
// module chunks = main